import API_PRODUCTS from '../../api/apiproducts.js';
import EventBus from '../../bus/events';

export const api_products = {
    state: () => ({
        products: [],
        product: {
            id: '',
            name: '',
            meta: {
                icon: '',
                color: ''
            },
            access: '',
            description: '',
            environment: []
        },
        apiProductErrors: {},
        productsLoaded: 0,
        creatingApiProduct: false,
        updatingApiProduct: false,
        productCreated: 0,
        editingApiProduct: false
    }),
    actions: {
        getApiProducts({commit}, page = 1) {
            commit('setApiProductErrors', {});
            commit('setProductsLoaded', 1);
            return API_PRODUCTS.getAll(page)
                .then((response) => {
                    commit('setProducts', response.data.data);
                    commit('setProductsLoaded', 2);
                }).catch(() => {
                    commit('setProductsLoaded', 3);
                });
        },

        findApiProductById({commit}, id) {
            return API_PRODUCTS.find(id).then(res => {
                commit('setApiProduct', res.data.data)
            });
        },
        createApiProduct({commit}, payload) {
            commit('setProductCreateStatus', 1);
            API_PRODUCTS.create(payload).then(res => {
                commit('setProductCreateStatus', 2);
                EventBus.$emit('api-product-created', res.data);
            }).catch(error => {
                commit('setProductCreateStatus', 3);
                if (error.response && error.response.status === 422) {
                    commit('setProductCreateStatus', 4);
                    commit('setApiProductErrors', error.response.data.errors)
                }
            })
        },

        updateProduct({dispatch, commit}, payload) {
            API_PRODUCTS.update(payload).then(res => {
                dispatch('getApiProducts');
                EventBus.$emit('api-product-updated', res.data);
            }).catch(error => {
                if (error.response && error.response.status === 422) {
                    commit('setApiProductErrors', error.response.data.errors)
                }
            })
        },

        deleteProduct({dispatch}, id) {
            API_PRODUCTS.delete(id).then(res => {
                dispatch('getApiProducts');
            });
        }
    },
    mutations: {

        setProducts(state, products) {
            state.products = products;
        },

        setApiProduct(state, product) {
            state.product = product;
        },

        setProductCreateStatus(state, status) {
            state.productCreated = status;
        },

        setProductsLoaded(state, status) {
            state.productsLoaded = status;
        },

        setApiProductErrors(state, errors) {
            state.apiProductErrors = errors;
        },

        setCreatingApiProduct(state, status) {
            state.creatingApiProduct = status;
        },

        setUpdatingApiProduct(state, status) {
            state.updatingApiProduct = status;
        },

        setEditingApiProduct(state, status) {
            state.editingApiProduct = status;
        },
    },
    /*
      Defines the getters used by the module
    */
    getters: {
        /*
          Returns the products load status.
        */
        editingApiProduct(state) {
            return state.editingApiProduct;
        },

        /*
          Returns the products load status.
        */
        getProductCreatedStatus(state) {
            return state.productCreated;
        },

        /*
          Returns the products load status.
        */
        getApiProductErrors(state) {
            return state.apiProductErrors;
        },

        /*
          Returns the the currently selected api product.
        */
        getApiProduct(state) {
            return state.product;
        },

        /*
          Returns the the api products.
        */
        getProducts(state) {
            return state.products;
        },

        getCreatingApiProduct(state) {
            return state.creatingApiProduct;
        },

        getUpdatingApiProduct(state) {
            return state.updatingApiProduct;
        }
    }
};
